module.exports = __webpack_public_path__ + "media/testimonials/2-10f62936.jpg";